import { Fragment, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Footer from "../component/layout/footer";
import Header from "../component/layout/header";
// import "./signup.css"; // optional for smooth animations
import "../assets/css/tutosignup.css";
import Category from "../component/section/category";
import { useRef } from "react";
import Swal from "sweetalert2";


const TutorSignupPage = () => {


    const navigate = useNavigate();
    const [role, setRole] = useState("tutor");
    const [step, setStep] = useState(1);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [categories, setCategories] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const [skillsInput, setSkillsInput] = useState("");
    const [skillsList, setSkillsList] = useState([]);
    const [skillSuggestions, setSkillSuggestions] = useState([]);
    const [suggestions, setSuggestions] = useState([]);
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [submittedStep1, setSubmittedStep1] = useState(false);
    const [type, setType] = useState("individual");
    const inputRef = useRef(null); 
    const [filteredCities, setFilteredCities] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [availableLanguages, setAvailableLanguages] = useState([]);
    const [langOpen, setLangOpen] = useState(false);
    const [emailChecking, setEmailChecking] = useState(false);
    const emailTimeoutRef = useRef(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [categorySearch, setCategorySearch] = useState("");
    const categoryRef = useRef(null);
    const langRef = useRef(null);
    const [isSubmitting, setIsSubmitting] = useState(false);


    




const [categoryOpen, setCategoryOpen] = useState(false);
    
const [selectedCurrency, setSelectedCurrency] = useState({
  code: "",
  symbol: ""
});



const handleCategoryToggle = async (categoryId) => {
  let updated;

  if (formData.category_ids.includes(categoryId)) {
    updated = formData.category_ids.filter(id => id !== categoryId);
  } else {
    updated = [...formData.category_ids, categoryId];
  }

  setFormData(prev => ({
    ...prev,
    category_ids: updated,
    skills: [] // reset skills
  }));

  setSkillsList([]);
  setSkillSuggestions([]);

  // 🔥 Fetch skills for ALL selected categories
  if (updated.length > 0) {
    const allSkills = [];

    for (let id of updated) {
      const res = await fetch(
        `https://kalakakshaaha.com/kks/api/v1/categories/${id}/skills`
      );
      const data = await res.json();
      if (data.success) {
        allSkills.push(...data.skills);
      }
    }

    // remove duplicates by id
    const uniqueSkills = Array.from(
      new Map(allSkills.map(s => [s.id, s])).values()
    );

    setSkillSuggestions(uniqueSkills);
  }
};


    const filteredLanguages = availableLanguages.filter(lang =>
    lang.language_name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const filteredCategories = categories.filter(cat =>
  cat.category_name.toLowerCase().includes(categorySearch.toLowerCase())
);


    const handleChange = (e) => {
           const { name, value } = e.target;

    // Validation: username should NOT contain numbers
    if (name === "username") {
        const onlyLetters = /^[A-Za-z ]*$/;

        if (!onlyLetters.test(value)) {
            // show validation error
            setErrors({ ...errors, username: "Numbers are not allowed" });
            return; // stop updating the input
        } else {
            // clear the error if text is valid
            setErrors({ ...errors, username: "" });
        }
    }
        setFormData({ ...formData, [e.target.name]: e.target.value });


        if (name === "email") {
    setErrors({ ...errors, email: "" });
 
    // basic format check first
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) return;
 
    // debounce
    if (emailTimeoutRef.current) {
      clearTimeout(emailTimeoutRef.current);
    }
 
    emailTimeoutRef.current = setTimeout(async () => {
      setEmailChecking(true);
 
      try {
        const res = await fetch(
         `https://kalakakshaaha.com/kks/api/v1/check-email?email=${value}&role=tutor`
        );
        const data = await res.json();
 
        if (data.exists) {
          setErrors((prev) => ({
            ...prev,
            email: "Email already registered"
          }));
        }
      } catch (err) {
        console.error(err);
      } finally {
        setEmailChecking(false);
      }
    }, 600); // ⏱️ wait until user stops typing
  }
        
        // hide error message while typing
    if (errors[e.target.name]) {
        setErrors({
            ...errors,
            [e.target.name]: ""
        });
    }
    
/* -------------------
     ON COUNTRY CHANGE
  ------------------- */
  if (e.target.name === "country_id") {
    const countryId = e.target.value;
    setFormData({ ...formData, country_id: countryId, state_id: "", city_id: "" });

    // Fetch states
    fetch(`https://kalakakshaaha.com/kks/api/v1/states/${countryId}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setStates(data.states);
          setCities([]); // Reset cities
        }
      });
  }

  /* -------------------
     ON STATE CHANGE
  ------------------- */
  if (e.target.name === "state_id") {
    const stateId = e.target.value;
    setFormData({ ...formData, state_id: stateId, city_id: "" });

    // Fetch cities
    fetch(`https://kalakakshaaha.com/kks/api/v1/cities/${stateId}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setCities(data.cities);
        }
      });
  }

///skills
if (e.target.name === "Category") {

  const categoryId = e.target.value;

  // Reset previous inputs
  setSkillsList([]);
  setSkillSuggestions([]);
  setSuggestions([]);
  setSkillsInput("");

  // Fetch skills for selected category
  fetch(`https://kalakakshaaha.com/kks/api/v1/categories/${categoryId}/skills`)
    .then(res => res.json())
    .then(data => {
      if (data.success) {
        // store only skill titles
        // const skillNames = data.skills.map(s => s.skill_title);
        // console.log(skillNames);
        // setSkillSuggestions(skillNames);
        setSkillSuggestions(data.skills); 
                //console.log(data.skills);

        
// Store full objects: [{id:1, skill_title:"Guitar"}, ...]

      }
    });

  setFormData({
    ...formData,
    Category: categoryId,
    skills: ""
  });
}




    };

    const [errors, setErrors] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
   category_ids: "",
    Experience:"",
    Address: "",
    phone: "",
    education: "",
    studentPhone: "",
    Address_line1:"",
    country:"",
    skills:"",
    // state:"",
    // country:"",
    // city:"",
    country_id:"",
    state_id:"",
    city_id:"",
    area:"",
    location:"",
    pincode:"",
    phone: "",
    institute_name: "",
    owner_name: "",
    gender:""
            });

    const [formData, setFormData] = useState({
        username: "",
        email: "",
        password: "",
        confirmPassword: "",
       category_ids: [],
        Experience:"",
        membership_plan:"free",
        Address: "",
        phone_code: "+91",
        phone: "",
        sub_category: "",
       skills: [],
        // bio: "",
        phone: "",
        city:"",
        gender: "",
        institute_name: "",
        owner_name: "",
        // country:"",
        // state:"",
        country_id:"",
        state_id:"",
        city_id:"",
        area:"",
        pincode:"",
        Address_line1:"",
        Address_line2:"",
        location:"",
        class_modes: [], 
    age_groups: [],  
    languages: [],
    is_demo_available: false, 
   fee_min: "",
fee_max: "",
         
    });


// Replace your handleCheckboxChange function with this:

const handleCheckboxChange = (e, field) => {
    const { value, checked } = e.target;
    
    setFormData(prev => {
        const currentArray = prev[field];
        let updatedList;
        
        // ✅ For languages field: convert to number
        if (field === "languages") {
            const numValue = parseInt(value, 10);
            updatedList = checked 
                ? [...currentArray, numValue]
                : currentArray.filter(item => item !== numValue);
        } 
        // ✅ For class_modes: keep as string (Online, Offline, Home)
        else {
            updatedList = checked 
                ? [...currentArray, value]
                : currentArray.filter(item => item !== value);
        }
        
        return { ...prev, [field]: updatedList };
    });
};





    const handleSkillInput = (e) => {
  const v = e.target.value;
  setSkillsInput(v);

  if (!v) {
    setSuggestions([]);
    return;
  }
// clear error while typing
    if (errors.skills) {
        setErrors(prev => ({ ...prev, skills: "" }));
    }
  const filtered = skillSuggestions.filter(s =>
  s.skill_title.toLowerCase().includes(v.toLowerCase()) &&
  !skillsList.some(x => x.id === s.id)
);

  setSuggestions(filtered);
    };

    const addSkill = (skill) => {
  if (!skill || skillsList.some(s => s.id === skill.id)) return;

  const updated = [...skillsList, { id: skill.id, title: skill.skill_title }];
  
  setSkillsList(updated);

  // send only IDs to backend
  const skillIds = updated.map(s => s.id);
  setFormData({ ...formData, skills: skillIds });
  
  setSkillsInput("");
  setSuggestions([]);
    };


    const removeSkill = (skillId) => {
     const updated = skillsList.filter(s => s.id !== skillId);
     setSkillsList(updated);

     const skillIds = updated.map(s => s.id);
     setFormData({ ...formData, skills: skillIds });
    };


    const onSkillKeyDown = (e) => {
  if (e.key === "Enter") {
    e.preventDefault();
    const val = skillsInput.trim();
    if (val) addSkill(val);
  }
   };
    

   

    const validateStep = () => {
       
        if (role === "tutor") {
    //         if (step === 1) {
    //             let newErrors = {};

    // if (!formData.username.trim()) {
    //     newErrors.username = "Username is required";
    // }

    // if (!formData.email.trim()) {
    //     newErrors.email = "Email is required";
    // } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
    //     newErrors.email = "Enter a valid email";
    // }
    //  if (!formData.phone.trim()) {
    //         newErrors.phone = "Phone number is required";
    //     } 
    //     else if (!/^[0-9]{10}$/.test(formData.phone)) {
    //         newErrors.phone = "Enter a valid 10-digit phone number";
    //     }

    // setErrors(newErrors);

    // return Object.keys(newErrors).length === 0; // true if no errors
    //         }
    if (step === 1) {
    let newErrors = {};

    if (type === "individual") {
        if (!formData.username.trim()) newErrors.username = "Name is required";
        if (!formData.email.trim()) newErrors.email = "Email is required";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
            newErrors.email = "Enter valid email";
        if (!formData.gender.trim()) newErrors.gender = "Gender is required";


        if (!formData.phone.trim()) newErrors.phone = "Phone required";
        else if (!/^[0-9]{10}$/.test(formData.phone))
            newErrors.phone = "Enter valid 10-digit number";
    }

    if (type === "institute") {
        if (!formData.institute_name?.trim())
            newErrors.institute_name = "Institute name required";


        if (!formData.gender.trim())
  newErrors.gender = "Gender is required";


        if (!formData.owner_name?.trim())
            newErrors.owner_name = "Contact person name required";

        if (!formData.email.trim()) newErrors.email = "Email required";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
            newErrors.email = "Enter valid email";

        if (!formData.phone.trim()) newErrors.phone = "Phone required";
        else if (!/^[0-9]{10}$/.test(formData.phone))
            newErrors.phone = "Enter valid 10-digit phone";

        // if (!formData.main_category?.trim())
        //     newErrors.main_category = "Main category required";

        // if (!formData.location?.trim())
        //     newErrors.location = "Location required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
}

if (step === 2) {
  let newErrors = {};

  // category
  if (!formData.category_ids.length) {
    newErrors.category_ids = "Select at least one category";
  }

  // skills
  if (!Array.isArray(formData.skills) || formData.skills.length === 0) {
    newErrors.skills = "At least one skill is required";
  }

  // experience
  if (!formData.Experience) {
    newErrors.Experience = "Experience is required";
  } else if (!/^\d+$/.test(formData.Experience)) {
    newErrors.Experience = "Experience must be a whole number";
  }

  // class modes (Online / Offline / Home)
  if (!formData.class_modes || formData.class_modes.length === 0) {
    newErrors.class_modes = "Select at least one class mode";
  }

  // languages
  if (!formData.languages || formData.languages.length === 0) {
    newErrors.languages = "Select at least one language";
  }

  // demo availability
  if (formData.is_demo_available === null) {
    newErrors.is_demo_available = "Please select demo availability";
  }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
}




            if (step === 3) {
    let newErrors = {};

    const pincode = String(formData.pincode || "").padStart(6, "0");
 
if (!formData.country_id) newErrors.country_id = "Country is required";
if (!formData.state_id) newErrors.state_id = "State is required";
    if (!formData.city_id) newErrors.city_id = "City is required";
    if (!formData.area.trim()) newErrors.area = "Area is required";
    if (!formData.location.trim()) newErrors.location = "Location is required";

    if (!formData.pincode) newErrors.pincode = "Pincode is required";
    else if (!/^[0-9]{6}$/.test(pincode))
        newErrors.pincode = "Pincode must be 6 digits";


if (!formData.fee_min) newErrors.fee_min = "Enter minimum fee";
if (!formData.fee_max) newErrors.fee_max = "Enter maximum fee";

if (
  Number(formData.fee_min) <= 0 ||
  Number(formData.fee_max) <= 0
) {
  newErrors.fee_min = "Fee must be greater than 0";
}

if (Number(formData.fee_min) > Number(formData.fee_max)) {
  newErrors.fee_max = "Max fee must be greater than Min fee";
}

    if (!formData.location.trim()) newErrors.location = "Location is required";

    if (!formData.Address_line1.trim())
       newErrors.Address_line1 = "Address is required";
      
       if (!formData.Address_line2.trim())
       newErrors.Address_line2 = "Address is required";
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
}

            if (step === 4) {
    let newErrors = {};

    // if (!formData.password.trim()) {
    //     newErrors.password = "Password is required";
    // } 
      if (!formData.password.trim()) {
  newErrors.password = "Password is required";
} else if (
  !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/.test(formData.password)

  //!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&]{8,}$/.test(formData.password)
) {
  newErrors.password =
    "8+ chars, upper, lower, number & special character required";
}

    else if (formData.password.length < 6) {
        newErrors.password = "Password must be at least 8 characters";
    }

    if (!formData.confirmPassword.trim()) {
        newErrors.confirmPassword = "Confirm password is required";
    } 
    else if (formData.password !== formData.confirmPassword) {
        newErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
}

        }
 
        return true;
    };

    const validateStepWithCityId = (cityId) => {
  let newErrors = {};
  const pincode = String(formData.pincode || "").padStart(6, "0");

  if (!formData.country_id) newErrors.country_id = "Country is required";
  if (!formData.state_id) newErrors.state_id = "State is required";
  if (!cityId) newErrors.city_id = "City is required";
  if (!formData.area.trim()) newErrors.area = "Area is required";

  if (!formData.pincode) newErrors.pincode = "Pincode is required";
  else if (!/^[0-9]{6}$/.test(pincode))
    newErrors.pincode = "Pincode must be 6 digits";

  if (!formData.location.trim()) newErrors.location = "Location is required";
  if (!formData.Address_line1.trim())
    newErrors.Address_line1 = "Address is required";

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
    };

    const nextStep = async () => {
    setSubmittedStep1(true);

  //  STEP 3 — ensure city & continue in SAME CLICK
  if (step === 3 && !formData.city_id && formData.city) {
    const newCityId = await ensureCityExists();

    if (!newCityId) {
      setErrors(prev => ({
        ...prev,
        city_id: "City is required"
      }));
      return;
    }

    //  Use city_id immediately (do NOT wait for state)
    if (validateStepWithCityId(newCityId)) {
      setStep(step + 1);
    }
    return;
  }

  // normal flow
  if (validateStep()) {
    setStep(step + 1);
  }
    };

 
    const prevStep = () => {
        if (step > 1) setStep(step - 1);
    };
 

    const handleSignup = async (e) => {
    e.preventDefault();
    
     if (isSubmitting) return; // 🚫 prevent double click
  setIsSubmitting(true);    // 🔒 disable submit button

    if (!validateStep()) {
    setIsSubmitting(false); // ✅ IMPORTANT FIX
    return;
  }

// 🔥 Ensure city exists before final submit
if (!formData.city_id && formData.city) {
  await ensureCityExists();
}
    // Run validation before submitting
  if (!formData.city_id) {
    setErrors(prev => ({
      ...prev,
      city_id: "City is required"
    }));
    setIsSubmitting(false); // ✅ ALSO REQUIRED
    return;
  }

    let url = "";
    let payload = {};

    payload = {
            username: formData.username,
            email: formData.email,
            password: formData.password,
            category_ids: formData.category_ids,// ID
            sub_category:formData.sub_category,
            skills: formData.skills,
            Experience:formData.Experience,
             membership_plan: formData.membership_plan,   // default plan
            Address: formData.Address,
                    phone_code: formData.phone_code,
            phone:  formData.phone,
            gender: formData.gender,
            
            // state: formData.state,
            // country: formData.country,
            // city: formData.city,
             country_id: formData.country_id,
             state_id: formData.state_id,
             city_id: formData.city_id,

            area: formData.area,
            pincode: formData.pincode,
            location: formData.location,
            Address_line1: formData.Address_line1,
            Address_line2: formData.Address_line2,
              is_online: formData.class_modes.includes("Online") ? 1 : 0,
        is_offline: formData.class_modes.includes("Offline") ? 1 : 0,
        is_home_tuition: formData.class_modes.includes("Home Visit") ? 1 : 0,
         languages: formData.languages,
         is_demo_available: formData.is_demo_available ? 1 : 0,
     fee_min: formData.fee_min,
fee_max: formData.fee_max,

        
        type: type
            
            

         };
         // Add user type to payload (individual / institute)
payload.type = type;


         // Add institute fields only if type === "institute"
if (type === "institute") {
    payload.institute_name = formData.institute_name;
    payload.owner_name = formData.owner_name;

    // full_name stored as institute_name
    payload.full_name = formData.institute_name;
}

// For individual, full_name = username
if (type === "individual") {
    payload.full_name = formData.username;
}

    const res = await fetch("https://kalakakshaaha.com/kks/api/v1/register/tutor", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
    });

    const data = await res.json();
if (data.success) {

  Swal.fire({

    icon: "success",

    title: "Registration Successful ",

    text: "A verification link has been sent to your email.",

    showConfirmButton: false,

    timer: 4000,

    timerProgressBar: true,

    width: 420,

    heightAuto: false,

    allowOutsideClick: false,

    didClose: () => {

      navigate("/login");

    }

  });

} else {

  Swal.fire({

    icon: "error",

    title: "Registration Failed",

    text: data.message || "Something went wrong",

    confirmButtonText: "OK",

    width: 400,

    heightAuto: false

  });
     setIsSubmitting(false);

  // 🎯 highlight backend field error if sent

  if (data.field) {

    setErrors(prev => ({

      ...prev,

      [data.field]: data.message

    }));

  }

}}

const handleCityChange = (e) => {
    const raw = e.target.value;

    // Remove numbers, capitalize first letter
    const lettersOnly = raw.replace(/[0-9]/g, "");
    const value = lettersOnly.charAt(0).toUpperCase() + lettersOnly.slice(1);

    setFormData(prev => ({
        ...prev,
        city: value,
        city_id: "" // reset city_id while typing
    }));

    // ✅ CLEAR CITY ERROR WHILE TYPING
    if (errors.city_id) {
        setErrors(prev => ({
            ...prev,
            city_id: ""
        }));
    }

    if (!value) {
        setFilteredCities([]);
        setShowSuggestions(false);
        return;
    }

    const results = cities.filter(c =>
        c.city_name.toLowerCase().includes(value.toLowerCase())
    );

    setFilteredCities(results);
    setShowSuggestions(true);
};


  const selectCity = (cityObj) => {
    setFormData({
        ...formData,
        city: cityObj.city_name,
        city_id: cityObj.id
    });
    // ✅ CLEAR CITY ERROR
    setErrors(prev => ({
        ...prev,
        city_id: ""
    }));
    setShowSuggestions(false);
    };

  const ensureCityExists = async () => {
  if (!formData.city) return null;
  if (formData.city_id) return formData.city_id;

  const res = await fetch(
    "https://kalakakshaaha.com/kks/api/v1/city/create-or-get",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        city_name: formData.city,
        state_id: formData.state_id,
        country_id: formData.country_id
      })
    }
  );

  const data = await res.json();

  if (data.success) {
    // ✅ update state
    setFormData(prev => ({
      ...prev,
      city_id: data.city_id
    }));

    // ✅ update cities list
    setCities(prev => [
      ...prev,
      { id: data.city_id, city_name: formData.city }
    ]);

    return data.city_id; // 🔥 RETURN IT
  }

  return null;
   };

 
    const totalSteps = 4;
    const progress = (step / totalSteps) * 100;
    const clearStep1Errors = () => {
    setErrors({
        username: "",
        email: "",
        phone: "",
        institute_name: "",
        owner_name: "",
    });

    
    };

    useEffect(() => {
     fetch("https://kalakakshaaha.com/kks/api/v1/countries")
     .then(res => res.json())
     .then(data => {
      if (data.success) {
        setCountries(data.countries);
      }
      })
      .catch(err => console.error("COUNTRIES ERROR:", err));
    }, []);

    useEffect(() => {
      fetch("https://kalakakshaaha.com/kks/api/v1/categories")
    .then(res => res.json())
    .then(data => {
      if (data.success) {
        setCategories(data.categories);
      }
    })
    .catch(err => console.error("FETCH ERROR:", err));
    }, []);


    useEffect(() => {
    fetch("https://kalakakshaaha.com/kks/api/v1/languages")
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                setAvailableLanguages(data.languages);
            }
        })
        .catch(err => console.error("LANGUAGES ERROR:", err));
}, []);





useEffect(() => {
  const handleClickOutside = (event) => {
    // close category dropdown
    if (
      categoryRef.current &&
      !categoryRef.current.contains(event.target)
    ) {
      setCategoryOpen(false);
    }

    // close language dropdown
    if (
      langRef.current &&
      !langRef.current.contains(event.target)
    ) {
      setLangOpen(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);



const selectedCategoryNames = categories
  .filter(cat => formData.category_ids.includes(cat.id))
  .map(cat => cat.category_name);

const selectedLanguageNames = availableLanguages
  .filter(lang => formData.languages.includes(lang.id))
  .map(lang => lang.language_name);

 
    return (
        <Fragment>
            <Header />
 
            {/* <PageHeader title={"Sign Up"} curPage={"Register"} /> */}
 
           <div className="signup-wrapper fadeIn" >
 
    <div className="container py-5" >
      <div style={{marginTop:110}}>
        <div className="signup-card shadow-lg" style={{margin:"50px auto"}}>
 
            <h3 className="text-center signup-title">Create Tutor Account</h3>
 
            {/* PROGRESS BAR */}
            <div className="progress my-4" style={{ height: "10px", borderRadius:"20px" }}>
                <div
                    className="progress-bar signup-progress"
                    role="progressbar"
                    style={{ width: `${progress}%` }}
                ></div>
            </div>
 
            
            {/* FORM START */}
            <form className="account-form step-animation" onSubmit={handleSignup}>
 
                {/* STUDENT → Step 1 */}
                {step === 1 && (
                    <div className="step-box">
                        {/* <h4 className="step-heading">Basic Info</h4> */}
                        <div className="toggle-row" >
        <button
          className={type === "individual" ? "toggle-btn active" : "toggle-btn"}
          onClick={() => {setType("individual");
            clearStep1Errors();
            setFormData({
        ...formData,
        username: "",
       
        gender: "",
    });
          }
        }
          
        >
          I am an Individual
        </button>

        <button
          className={type === "institute" ? "toggle-btn active" : "toggle-btn"}
          onClick={() => {setType("institute");clearStep1Errors();
                setFormData({
        ...formData,
        institute_name: "",
        owner_name: "",
       
    });

          }}
        >
          I run an Institute
        </button>
      </div>
      {type === "institute" && (
    <>

                        <div className="input-wrapper">

        <input
            type="text"
            className="step-input"
            name="owner_name"
            placeholder="Owner or Contact Person's Name"
            value={formData.owner_name || ""}
            onChange={handleChange}
        />
        
        {submittedStep1 && errors.owner_name && (
    <p className="validation-msg show">{errors.owner_name}</p>
)}
    
        </div>


    {/* ✅ ADD THIS — GENDER FIELD */}
    <div className="select-box">
      <select
        className="step-input"
        name="gender"
        value={formData.gender}
        onChange={handleChange}
      >
        <option value="">Select Gender</option>
        <option value="male">Male</option>
        <option value="female">Female</option>
        <option value="other">Other</option>
      </select>

      {submittedStep1 && errors.gender && (
        <p className="validation-msg show">{errors.gender}</p>
      )}
    </div>


                                    <div className="input-wrapper">

        <input
            type="text"
            className="step-input"
            name="institute_name"
            placeholder="Institute name e.g. T.I.M.E"
            value={formData.institute_name || ""}
            onChange={handleChange}
        />
            {/* <p className={`validation-msg ${errors.institute_name ? "show" : ""}`}>
        {errors.institute_name}
    </p> */}
    {submittedStep1 && errors.institute_name && (
    <p className="validation-msg show">{errors.institute_name}</p>
)}

        </div>


                        <div className="input-wrapper">

        <input
            type="email"
            className="step-input"
            name="email"
            placeholder="Enter your Email Eg: time@gmail.com"
            value={formData.email}
            onChange={handleChange}
        />
         <p className="hint">
        Please enter a valid email for verification
    </p>

    {/* SHOW ERROR ONLY IF errors.email exists */}
   
{errors.email && (
  <p className="validation-msg show">{errors.email}</p>
)}

        
        </div>

<div className="input-wrapper">
    <div className="phone-row">
        <select
    className="step-input"
    name="phone_code"
    value={formData.phone_code}
    onChange={handleChange}
>
    <option value="+91">India (+91)</option>
    <option value="+1">USA (+1)</option>
    <option value="+44">UK (+44)</option>
</select>

        <input type="tel" name="phone" value={formData.phone} onChange={(e) => {
    const value = e.target.value.replace(/\D/g, ""); // only digits
    if (value.length <= 10) {
      setFormData({ ...formData, phone: value });
    }
    // ✅ CLEAR ERROR WHILE TYPING
      if (errors.phone) {
        setErrors(prev => ({ ...prev, phone: "" }));
      }
  }}className="step-input" placeholder="Enter your Mobile Number" maxLength={10} />
        
      </div>
      {/* <p className={`validation-msg ${errors.phone ? "show" : ""}`}>
                                {errors.phone}
         </p> */}
          {submittedStep1 && errors.phone && (
    <p className="validation-msg show">{errors.phone}</p>
)}
</div>

       
    </>
)}
{type === "individual" && (
    <>
           <div className="input-wrapper">
    <input 
        type="text" 
        name="username" 
        placeholder="Name"
        className="step-input"
        value={formData.username}
        onChange={handleChange}
    />
    {/* <p className={`validation-msg ${errors.username ? "show" : ""}`}>
        {errors.username}
    </p> */}
    {submittedStep1 && errors.username && (
    <p className="validation-msg show">{errors.username}</p>
)}


</div>
                        
<div className={`input-wrapper ${errors.email ? "error-active" : ""}`}>
  <input
    type="email"
    name="email"
    placeholder="Email"
    className="step-input"
    value={formData.email}
    onChange={handleChange}
  />
 
  <p className="hint">
    Please enter a valid email for verification
  </p>
 
  {emailChecking && (
    <p className="hint">Checking email availability...</p>
  )}
 
  <p className={`validation-msg ${errors.email ? "show" : ""}`}>
    {errors.email}
  </p>
</div>
                        {/* <input type="number" name="phone" placeholder="Phone Number"
                            className="step-input" value={formData.phone} onChange={handleChange} />
                            <p className={`validation-msg ${errors.phone ? "show" : ""}`}>
                                {errors.phone}
                             </p> */}
<div className="input-wrapper">
    <div className="phone-row">
        <select
    className="step-input"
    name="phone_code"
    value={formData.phone_code}
    onChange={handleChange}
>
    <option value="+91">India (+91)</option>
    <option value="+1">USA (+1)</option>
    <option value="+44">UK (+44)</option>
</select>

        <input type="number" name="phone" value={formData.phone} onChange={(e) => {
    const value = e.target.value.replace(/\D/g, ""); // only digits
    if (value.length <= 10) {
      setFormData({ ...formData, phone: value });
    }
     // ✅ CLEAR ERROR WHILE TYPING
      if (errors.phone) {
        setErrors(prev => ({ ...prev, phone: "" }));
      }
  }} className="step-input" placeholder="Enter your Mobile Number" maxLength={10} />
        
      </div>
      {/* <p className={`validation-msg ${errors.phone ? "show" : ""}`}>
                                {errors.phone}
                             </p> */}
                              {submittedStep1 && errors.phone && (
    <p className="validation-msg show">{errors.phone}</p>
)}
</div>
                        
      <div className="select-box">
<select
    className="step-input"
    name="gender"
    value={formData.gender}
    onChange={handleChange}
>
    <option value="">Select Gender</option>
    <option value="male">Male</option>
    <option value="female">Female</option>
    <option value="other">Other</option>
</select>
 {submittedStep1 && errors.gender && (
    <p className="validation-msg show">{errors.gender}</p>
)}

      </div>
    </>
)}

 
                        
    
                    </div>
                )}
              
 
                {step === 2 && (
                    <div className="step-box">
 
                        {/* <input type="text" name="Category" placeholder="Specialization"
                            className="step-input" value={formData.Category} onChange={handleChange} /> */}

                               <div className="input-wrapper ">
 {/* <label className="fw-bold mb-2">Select Categories</label>*/}

   <div className="custom-dropdown" ref={categoryRef}>

      
      <div
        className="custom-dropdown-input"
        onClick={() => setCategoryOpen(prev => !prev)}
        
      >
        
      <span>
  {selectedCategoryNames.length > 0
    ? selectedCategoryNames.join(", ")
    : "Select Categories.."}
</span>

        
        <span className="dropdown-arrow">▾</span>
      </div>
      

  {categoryOpen && (
    <div className="custom-dropdown-menu">

      {/* 🔍 SEARCH INPUT (same as language) 
      <div className="dropdown-search-wrapper">
        <input
          type="text"
          placeholder="Search categories..."
          className="dropdown-search-input"
          value={categorySearch}
          onChange={(e) => setCategorySearch(e.target.value)}
          autoFocus
        />
      </div>*/}

  <div className="options-container">
    {filteredCategories.length > 0 ? (
      filteredCategories.map(cat => (
        <label key={cat.id} className="dropdown-option">
          <span className="option-text">{cat.category_name}</span>
          <input
            type="checkbox"
            checked={formData.category_ids.includes(cat.id)}
            onChange={() => handleCategoryToggle(cat.id)}
          />
        </label>
      ))
    ) : (
      <div className="no-results">No categories found</div>
    )}
  </div>


    </div>
  )}

    </div>

  {errors.category_ids && (
    <p className="validation-msg show">{errors.category_ids}</p>
  )}
</div>


                            

                          
         {/* <input type="text" name="skills" placeholder="Skills"
                            className="step-input" value={formData.skills} onChange={handleChange} /> */}
                            {/* Skills input & chips (Step 2) */}
                                         <div className="input-wrapper">

<div className="skills-wrapper" style={{marginBottom:"0px"}}>

  <div
    className="skills-input-wrapper"
    onClick={() => inputRef.current?.focus()}
  >

    {skillsList.map((skill, idx) => (
      <span key={idx} className="skill-chip-inline">
        {skill.title}
        <button
          className="remove-chip-inline"
          onClick={(e) => {
            e.stopPropagation();
            removeSkill(skill.id);
          }}
        >
          ×
        </button>
      </span>
    ))}

    <input
      ref={inputRef}
      type="text"
      className="skills-inline-input"
      placeholder="Select SubCategories..."
      value={skillsInput}
      onChange={handleSkillInput}
      onKeyDown={onSkillKeyDown}
    />
  </div>

   <p className={`validation-msg ${errors.skills ? "show" : ""}`}>
                                 {errors.skills}
    </p>
     </div>

  {suggestions.length > 0 && (
    <ul className="skills-suggestions">
      {suggestions.map((s, i) => (
        <li key={i} onClick={() => addSkill(s)}>
          {s.skill_title}
        </li>
      ))}
    </ul>
  )}

</div>
  {/* <p className={`validation-msg ${errors.skills ? "show" : ""}`}>
            {errors.skills}
        </p> */}
         <div className="input-wrapper">
        <input
  type="number"
  name="Experience"
  placeholder="Experience in Years"
  className="step-input"
  value={formData.Experience}
  min="0"
  step="1"
  onChange={(e) => {
    const value = e.target.value;

    // allow only integers
    if (/^\d*$/.test(value)) {
      setFormData({ ...formData, Experience: value });

      // clear error while typing
      if (errors.Experience) {
        setErrors(prev => ({ ...prev, Experience: "" }));
      }
    }
  }}
/>

         <p className={`validation-msg ${errors.Experience ? "show" : ""}`}>
            {errors.Experience}
        </p></div>
            {/* MEMBERSHIP PLAN SELECTION 
<div className="plan-box">
    <h4 className="step-heading">Choose Your Membership Plan</h4>

<div className="plan-select-wrapper">

    {/* PREMIUM 
    <div
        className={`plan-card ${formData.membership_plan === "premium" ? "active" : ""}`}
        onClick={() => setFormData({...formData, membership_plan: "premium"})}
    >
        <div className="plan-title">Premium</div>
        <div className="plan-price">₹1499 / month</div>
        <div className="plan-desc">Top Listing Priority</div>
    </div>

    {/* SILVER (Normal) 
    <div
        className={`plan-card ${formData.membership_plan === "silver" ? "active" : ""}`}
        onClick={() => setFormData({...formData, membership_plan: "silver"})}
    >
        <div className="plan-title">Silver</div>
        <div className="plan-price">₹799 / month</div>
        <div className="plan-desc">Mid-Level Listing</div>
    </div>

    {/* BASIC 
    <div
        className={`plan-card ${formData.membership_plan === "basic" ? "active" : ""}`}
        onClick={() => setFormData({...formData, membership_plan: "basic"})}
    >
        <div className="plan-title">Basic</div>
        <div className="plan-price">₹0</div>
        <div className="plan-desc">Basic Listing</div>
    </div>

</div>

</div>*/}
{/* CLASS CONDUCT MODES */}
<div className="input-wrapper mb-4">
  <label className="fw-bold mb-2">
    How would you like to conduct your classes?
  </label>

  <div className="option-box-group">
    {["Online", "Offline", "Home Visit"].map(mode => (
      <label
        key={mode}
        className={`option-box ${
          formData.class_modes.includes(mode) ? "active" : ""
        }`}
      >
        <input
          type="checkbox"
          value={mode}
          checked={formData.class_modes.includes(mode)}
          onChange={(e) => handleCheckboxChange(e, "class_modes")}
        />
        {mode}
      </label>
    ))}
  </div>

  {errors.class_modes && (
    <p className="validation-msg show">{errors.class_modes}</p>
  )}
</div>


<div className="input-wrapper mb-4">
    <label className="fw-bold mb-2">Languages you teach</label>

   <div className="custom-dropdown" ref={langRef}>

      <div
        className="custom-dropdown-input"
        onClick={() => setLangOpen(!langOpen)}
      >
       <span>
  {selectedLanguageNames.length > 0
    ? selectedLanguageNames.join(", ")
    : "Select Languages"}
</span>

        <span className="dropdown-arrow">▾</span>
      </div>

      {langOpen && (
        <div className="custom-dropdown-menu">
          {/* 3. SEARCH INPUT FIELD */}
          <div className="dropdown-search-wrapper">
            <input
              type="text"
              placeholder="Search languages..."
              className="dropdown-search-input"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              autoFocus
            />
          </div>

          <div className="options-container">
            {filteredLanguages.length > 0 ? (
              filteredLanguages.map(lang => (
                <label key={lang.id} className="dropdown-option">
                  <span className="option-text">{lang.language_name}</span>
                  <input
                    type="checkbox"
                    checked={formData.languages.includes(lang.id)}
                    onChange={() => {
                      const updated = formData.languages.includes(lang.id)
                        ? formData.languages.filter(id => id !== lang.id)
                        : [...formData.languages, lang.id];

                      setFormData({ ...formData, languages: updated });
                    }}
                  />
                </label>
              ))
            ) : (
              <div className="no-results">No languages found</div>
            )}
          </div>

          
        </div>
      )}
    </div>

    {errors.languages && (
      <p className="validation-msg show">{errors.languages}</p>
    )}
  </div>






<div className="input-wrapper mb-4">
  <label className="fw-bold mb-2">Available for Demo Class?</label>

  <div className="option-box-group">
    <label
      className={`option-box ${
        formData.is_demo_available === true ? "active" : ""
      }`}
    >
      <input
        type="radio"
        name="is_demo_available"
        onChange={() =>
          setFormData({ ...formData, is_demo_available: true })
        }
      />
      YES
    </label>

    <label
      className={`option-box ${
        formData.is_demo_available === false ? "active" : ""
      }`}
    >
      <input
        type="radio"
        name="is_demo_available"
        onChange={() =>
          setFormData({ ...formData, is_demo_available: false })
        }
      />
      NO
    </label>
  </div>

  {errors.is_demo_available && (
    <p className="validation-msg show">{errors.is_demo_available}</p>
  )}
</div>




        
 
                        {/* <input type="text" name="Address" placeholder="Address"
                            className="step-input" value={formData.Address} onChange={handleChange} />
                             <p className={`validation-msg ${errors.Address ? "show" : ""}`}>
            {errors.Address}
        </p> */}
                    </div>
                   )}

                {/* TUTOR → Step 3 */}
                { step === 3 && (
                     <div className="step-box">
                        {/* <h4 className="step-heading">More About You</h4> */}
                    <div className="address-inputs">
                            
                        <div className={`input-wrapper ${errors.country ? "error-active" : ""}`}>
                                {/* <input type="text" name="country" className="step-input" placeholder="Country" value={formData.country}
                                onChange={handleChange}/> */}
                               <select name="country_id" className="step-input" value={formData.country_id}
                                        onChange={handleChange}
                                                                            >
                                    <option value="">Select Country</option>

                                        {countries.map(c => (
                                         <option key={c.id} value={c.id}>
                                        {c.country_name}
                                    </option>
                                     ))}
                                 </select>

                                <p className={`validation-msg ${errors.country_id ? "show" : ""}`}>
                                 {errors.country_id}
                                </p>
                        </div>
                            
                        <div className={`input-wrapper ${errors.state ? "error-active" : ""}`}>
                            {/* <input type="text" name="state"  className={`step-input ${errors.state ? "error-active" : ""}`} placeholder="State" value={formData.state}
                                         onChange={handleChange}/> */}
                                         <select name="state_id" className="step-input" value={formData.state_id} onChange={handleChange}
                                             disabled={!formData.country_id}>
                                             <option value="">Select State</option>

                                                    {states.map(s => (
                                                          <option key={s.id} value={s.id}>
                                                                    {s.state_name}
                                                               </option>
                                                     ))}
                                            </select>

                                    <p className={`validation-msg ${errors.state_id ? "show" : ""}`}>
                                       {errors.state_id}
                                    </p>
                        </div>
                    </div>




<div className="input-wrapper">
  <label className="fw-bold mb-2">Fee per Session</label>

  <div style={{
    display: "flex",
    alignItems: "center",
    border: "1px solid #ccc",
    borderRadius: "4px",
    overflow: "hidden"
  }}>

    {/* CURRENCY SYMBOL */}
    <span style={{
      backgroundColor: "#f0f0f0",
      padding: "10px 15px",
      fontSize: "16px",
      fontWeight: "bold",
      minWidth: "50px",
      textAlign: "center",
      borderRight: "1px solid #ccc"
    }}>
      {countries.find(c => c.id === parseInt(formData.country_id))?.currency_symbol || "₹"}
    </span>

    {/* MIN FEE */}
    <input
      type="number"
      placeholder="Min"
      className="step-input"
      value={formData.fee_min}
      onChange={(e) => {
        setFormData({ ...formData, fee_min: e.target.value });
        if (errors.fee_min) setErrors(prev => ({ ...prev, fee_min: "" }));
      }}
      min="0"
      step="100"
      style={{
        flex: 1,
        border: "none",
        outline: "none",
        padding: "10px 15px",
        fontSize: "14px"
      }}
    />

    <span style={{
      fontSize: "18px",
      fontWeight: "bold",
      padding: "0 10px",
      color: "#555"
    }}>
      –
    </span>

        <span style={{
      backgroundColor: "#f0f0f0",
      padding: "10px 15px",
      fontSize: "16px",
      fontWeight: "bold",
      minWidth: "50px",
      textAlign: "center",
      borderRight: "1px solid #ccc"
    }}>
      {countries.find(c => c.id === parseInt(formData.country_id))?.currency_symbol || "₹"}
    </span>

    {/* MAX FEE */}
    <input
      type="number"
      placeholder="Max"
      className="step-input"
      value={formData.fee_max}
      onChange={(e) => {
        setFormData({ ...formData, fee_max: e.target.value });
        if (errors.fee_max) setErrors(prev => ({ ...prev, fee_max: "" }));
      }}
      min="0"
      step="100"
      style={{
        flex: 1,
        border: "none",
        outline: "none",
        padding: "10px 15px",
        fontSize: "14px"
      }}
    />
  </div>

  {/* CURRENCY CODE */}
  {formData.country_id && (
    <small style={{ color: "#666", marginTop: "6px", display: "block" }}>
      Currency: {countries.find(c => c.id === parseInt(formData.country_id))?.currency_code || "N/A"}
    </small>
  )}

  {/* ERROR MESSAGE */}
  {(errors.fee_min || errors.fee_max) && (
    <p className="validation-msg show">
      {errors.fee_min || errors.fee_max}
    </p>
  )}
</div>



                    <div className="address-inputs">
                        <div className={`input-wrapper ${errors.pincode ? "error-active" : ""}`}>
                                <input type="number"  className="step-input" name="pincode" placeholder="Pincode/ZIP" value={formData.pincode} 
                                onChange={(e) => {
                                    if (e.target.value.length <= 6) {handleChange(e)}}}/>
                                <p className={`validation-msg ${errors.pincode ? "show" : ""}`}>
                                 {errors.pincode}
                                </p>
                        </div>
                        <div className={`input-wrapper ${errors.city ? "error-active" : ""}`}>
    <input
        type="text"
        className="step-input no-margin"
        name="city"
        placeholder="Type your city "
        value={formData.city}
        onChange={handleCityChange}
        autoComplete="off"
        disabled={!formData.state_id}
    />
{showSuggestions && filteredCities.length === 0 && formData.city && (
  <div className="no-city-msg">
    Type your City it will be added automatically
  </div>
)}
    {/* Suggestions Dropdown */}
    {showSuggestions && filteredCities.length > 0 && (

      
        <ul className="suggestions-list">
            {filteredCities.map((c) => (
                <li key={c.id} onClick={() => selectCity(c)}>
                    {c.city_name}
                </li>
            ))}
        </ul>
    )}

    <p className={`validation-msg ${errors.city_id ? "show" : ""}`}>
        {errors.city_id}
    </p>
</div>

                    </div>
                    <div className={`input-wrapper ${errors.area ? "error-active" : ""}`}>
                                <input type="text"  className="step-input" name="area" placeholder="Area" value={formData.area} onChange={handleChange} />

                                <p className={`validation-msg ${errors.area ? "show" : ""}`}>
                                 {errors.area}
                                </p>
                    </div>
                     <div className={`input-wrapper ${errors.location ? "error-active" : ""}`}>
                                <input  type="text" className="step-input" name="location" placeholder="Location" value={formData.location} onChange={handleChange}/>

                                <p className={`validation-msg ${errors.location ? "show" : ""}`}>
                                 {errors.location}
                                </p>
                    </div>
                    <div className={`input-wrapper ${errors.Address_line1 ? "error-active" : ""}`}>
                                <input type="text" name="Address_line1" placeholder="Address line1"
                            className="step-input" value={formData.Address_line1} onChange={handleChange} />

                                <p className={`validation-msg ${errors.Address_line1 ? "show" : ""}`}>
                                 {errors.Address_line1}
                                </p>
                    </div>
                    <div className={`input-wrapper ${errors.Address_line2 ? "error-active" : ""}`}>
                                <input type="text" name="Address_line2" placeholder="Address line2"
                            className="step-input" value={formData.Address_line2} onChange={handleChange} />
                             <p className={`validation-msg ${errors.Address_line2 ? "show" : ""}`}>
                                 {errors.Address_line2}
                                </p>

                                {/* <p className={`validation-msg ${errors.Address_line1 ? "show" : ""}`}>
                                 {errors.Address_line1}
                                </p> */}
                     </div>
                   </div>
                    
                )}
 
                {/* TUTOR → Step 4 */}
                {step === 4 && (
                     <div className="step-box">
        {/* <h4 className="step-heading">Secure Your Account</h4> */}
<div className="input-wrapper">
        <div className="password-box">
    <input
        type={showPassword ? "text" : "password"}
        name="password"
        placeholder="Password"
        className="step-input"
        value={formData.password}
        onChange={handleChange}
    />
<i
        className={`fa-solid ${showPassword ? "fa-eye" : "fa-eye-slash"} eye-icon`}
        onClick={() => setShowPassword(!showPassword)}
    ></i>
<p className={`validation-msg ${errors.password ? "show" : ""}`}>
    {errors.password}
</p>
</div>
</div>


<div className="password-box">
    <input
        type={showConfirmPassword ? "text" : "password"}
        name="confirmPassword"
        placeholder="Confirm Password"
        className="step-input"
        value={formData.confirmPassword}
        onChange={handleChange}
    />
    
    <i
        className={`fa-solid ${showConfirmPassword ? "fa-eye" : "fa-eye-slash"} eye-icon`}
        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
    ></i>
</div>
<p className={`validation-msg ${errors.confirmPassword ? "show" : ""}`}>
    {errors.confirmPassword}
</p>

    </div>
                )}
 
                {/* BUTTONS */}
                <div className="btn-area">
 
                    {step > 1 && (
                        <button type="button" className="btn-prev" onClick={prevStep}>
                             Previous
                        </button>
                    )}
 
                    {step < totalSteps && (
                       <button
    type="button"
    className="btn-next"
    onClick={nextStep}
    
>
    Next →
</button>

                    )}
 
                    {step === totalSteps && (
                      <button
    type="submit"
    className={`submit-btn {isSubmitting? "btn-disabled" : ""}`}
    disabled={isSubmitting}
  >
    {isSubmitting ? "Registering..." : "Register"}
  </button>
                    )}
 
                </div>
 
            </form>
 
            <p className="text-center mt-2" style={{marginBottom:'5px'}}>
                Already have an account? <Link to="/login" className="login-link">Login</Link>
            </p>
 
        </div>
        </div>
    </div>
</div>
 
            <Footer />
        </Fragment>
    );
};
 
export default TutorSignupPage;

 